module.exports = __webpack_public_path__ + "img/spacelun.e62c1ad6.png";